<template>
  <div class="containar">
    <iframe class="frame" :src="iframeSrc" frameborder="0" height="100%"></iframe>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    iframeSrc() {
      const baseUrl = process.env.NODE_ENV === 'production' ? '/sysbgl/html' : '/html';
      return baseUrl + '/screen1/index.html';
    }
  },
  created() { },
  mounted() { },
  methods: {},
};
</script>

<style scoped>
html,
body,
#app,
.containar,
.frame {
  height: 100%;
  width: 100%;
  padding: 0px;
  margin: 0px;
}

.frame {
  height: 100vh !important;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/bigScreen/BigScreen1.vue